import { useState, useEffect } from "react";

export default function WindowWidth() {
  const [dimensions, setDimensions] = useState([window.innerHeight, window.innerWidth]);

  useEffect(() => {
    function handleResize() {
      setDimensions([window.innerHeight, window.innerWidth]);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return dimensions;
}
